<template>
	<div id="app">
		<div id="safe-area-top"></div>
		<router-view/>
		<notifications classes="zpevnik-notification" position="center bottom" />
		<Loading/>
	</div>
</template>

<script>
	import Loading from "@/components/loading/Loading";
	export default {
		components: { Loading },
		mounted() {
			var failElement = document.getElementById("fail");
			if (failElement) {
				failElement.parentNode.removeChild(failElement);
			}
		}

	}
</script>

<style lang="scss">
	/* inconsolata-500 - latin-ext_latin */
	@font-face {
		font-family: 'Inconsolata';
		font-style: normal;
		font-weight: 500;
		src: local(''),
		url('/fonts/inconsolata-v30-latin-ext_latin-500.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
		url('/fonts/inconsolata-v30-latin-ext_latin-500.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* inconsolata-regular - latin-ext_latin */
	@font-face {
		font-family: 'Inconsolata';
		font-style: normal;
		font-weight: 400;
		src: local(''),
		url('/fonts/inconsolata-v30-latin-ext_latin-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
		url('/fonts/inconsolata-v30-latin-ext_latin-regular.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* inconsolata-600 - latin-ext_latin */
	@font-face {
		font-family: 'Inconsolata';
		font-style: normal;
		font-weight: 600;
		src: local(''),
		url('/fonts/inconsolata-v30-latin-ext_latin-600.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
		url('/fonts/inconsolata-v30-latin-ext_latin-600.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* inconsolata-700 - latin-ext_latin */
	@font-face {
		font-family: 'Inconsolata';
		font-style: normal;
		font-weight: 700;
		src: local(''),
		url('/fonts/inconsolata-v30-latin-ext_latin-700.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
		url('/fonts/inconsolata-v30-latin-ext_latin-700.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	body {
		font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
		font-weight: 300;
		background-color: #323a40;

		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	html, body {
		overflow: hidden;
	}

	textarea, input[type="range"], input, input:matches([type="password"], [type="search"]) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	#safe-area-top {
		position: absolute;
		background-color: #323a40;
		top: 0;
		width: 100%;
		height: 0;
		height: constant(safe-area-inset-top);
		height: env(safe-area-inset-top);
		z-index: 48;
	}

	.zpevnik-notification {
		font-size: 16px;
		padding: 10px;
		margin: 0;
		width: 100%;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		line-height: 1.5em;

		color: rgba(255, 255, 255, 0.85);
		border-left: 5px solid #187FE7;

		&.error {
			background: #c66b73;
			border-left-color: #9a4e55;
			padding: 20px;
		}

		&.success {
			background: #408d7b;
			border-left-color: #367162;
		}
	}

	.v--modal-overlay {
		background: rgba(0, 0, 0, 0.6) !important;
	}

	@media print {

		@page {
			margin: 1cm;
		}

		html, body {
			overflow: visible !important;

			#songs-side, #root-side {
				display: none !important;
			}

			#detail, #export-detail, #session-detail {
				background-color: white !important;
				color: black !important;
				left: 0 !important;
				top: 0 !important;
				z-index: 10000 !important;
				width: 100% !important;
				height: 100%;
				position: relative;

				.bottom-white-space {
					display: none;
				}

				#detail-scroll {
					width: 100% !important;
					&::-webkit-scrollbar {
						width: 0 !important
					}

					span.chord {
						> span {
							background-color: white !important;
							color: black !important;
						}
					}
				}

				#detail-overlay {
					display: none !important;
				}
			}
		}
	}
</style>
